import { StatementOperatorTypes } from "../context/CustomField/CustomFieldTypes"

export type SubConditionOperator = null | 'AND' | 'OR'

export enum ObjectTypeEnum {
    'NOT_SET' = '-1',
    'Requisition' = '1',
    'Candidate' = '2',
}

export type StatementOperator = string

type SubConditionStatementValues = Array<string> | Array<number>

export interface SubConditionStatement {
    operator: StatementOperator
    values: SubConditionStatementValues
}

export default interface SubCondition<T extends SubConditionStatement> {
    fieldEId: string
    objectType: ObjectTypeEnum
    order: number
    operator: SubConditionOperator
    statement: T
}

export interface DateSubConditionStatement extends SubConditionStatement {
    operator: string
    values: Array<string>
}

export interface CurrencySubConditionStatement extends SubConditionStatement {
    operator: string
    values: Array<number>
}

export type AllowedConditionStatements = 
    DateSubConditionStatement |
    CurrencySubConditionStatement

export type SubConditionType = SubCondition<AllowedConditionStatements>
export interface SubConditionPayloadType {
    fieldEId: string
    objectType: 'Job' | 'Candidate' | '' | null
    operator: SubConditionOperator
    orderNumber: number
    statementContentList: Array<{content: string}>
    statementOperator: StatementOperatorTypes
}